import React from 'react';
import { ICON } from 'resources/constants';

import {
  Position,
  UserPosition,
  PositionTableData,
  LeaderPosition,
  LargeAvatar,
  SmallAvatar,
  Name,
  NameWrapper,
  NameTableData,
  Activities,
  ValueWrapper,
  Icon,
} from './elements';

type Props = {
  readonly className?: string;
  readonly position: number;
  readonly activities: number;
  readonly value: string | number;
  readonly noValue?: boolean;
  readonly name: string;
  readonly isLoading?: boolean;
  readonly avatarImage?: string;
  readonly isEmphasised?: boolean;
  readonly icon: string;
  readonly color?: string;
  readonly isSmall?: boolean;
};

export default function LBCo6({
  className,
  position,
  activities,
  value,
  noValue,
  name,
  isLoading,
  avatarImage,
  isEmphasised,
  icon,
  color,
  isSmall,
}: Props): React.ReactElement {
  const isLeader = !noValue && position === 1;
  const pos = noValue ? '-' : position;
  const isBig = isLeader || isEmphasised;

  function renderPosition() {
    if (isLeader) {
      return <LeaderPosition icon={ICON.crown}>{pos}</LeaderPosition>;
    }

    if (isEmphasised) {
      return <UserPosition>{pos}</UserPosition>;
    }

    return <Position>{pos}</Position>;
  }

  return (
    <tr className={className}>
      <PositionTableData $isUser={isEmphasised}>
        {renderPosition()}
      </PositionTableData>
      <NameTableData>
        <NameWrapper $isBig={isBig}>
          {isBig ? (
            <LargeAvatar isLoading={isLoading} image={avatarImage} />
          ) : (
            <SmallAvatar isLoading={isLoading} image={avatarImage} />
          )}
          <Name>{name}</Name>
        </NameWrapper>
      </NameTableData>
      {!isSmall && (
        <td>
          <Activities icon={ICON.checkCircle}>{activities}</Activities>
        </td>
      )}
      <td>
        <ValueWrapper>
          <Icon icon={icon || ICON.leaf} $iconColor={color}>
            {value}
          </Icon>
        </ValueWrapper>
      </td>
    </tr>
  );
}
